import { render, staticRenderFns } from "./predictionFunnel.vue?vue&type=template&id=06c75bb8"
import script from "./predictionFunnel.vue?vue&type=script&lang=js"
export * from "./predictionFunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports